import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchDocumentHistory } from "../../../store/documentSupervisorShow/actions/fetchDocumentHistory";
import { findDocument } from "../../../store/documentSupervisorShow/actions/findDocument";
import { findSigners } from "../../../store/documentSupervisorShow/actions/findSigners";

export const ParamsWatcher: React.FC = () => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  useEffect(() => {
    dispatch(findDocument(id));
    dispatch(findSigners(id));
    dispatch(fetchDocumentHistory(id));
  }, [dispatch, id]);
  return <></>;
};
